export enum TypeKeys {
  CREATE_BOARD = 'CREATE_BOARD',
  RESIZE_BOARD = 'RESIZE_BOARD',
  ADD_PLAYER = 'ADD_PLAYER',
  MODIFY_PLAYER = 'MODIFY_PLAYER',
  REMOVE_PLAYER = 'REMOVE_PLAYER',
  SET_PLAYERS_AMOUNT = 'SET_PLAYESR_AMOUNT',
  CHANGE_DIRECTION = 'CHANGE_DIRECTION',
  SET_OPTIMIZATION = 'SET_OPTIMIZATION',
  TICK = 'TICK',
  PAUSE = 'PAUSE',
  RESUME = 'RESUME',
  RESTART = 'RESTART',
  SET_GAME_TIME = 'SET_GAME_TIME',
  SET_STARTING_TERRITORY = 'SET_STARTING_TERRITORY',
  ACTOR_ACTION = 'ACTOR_ACTION',
  TOUCH_SET = 'TOUCH_SET',
  CHANGE_MAP_TEMPLATE = 'CHANGE_MAP_TEMPLATE',
  SHOW_SETTINGS = 'SHOW_SETTINGS'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/ColorWars/ReduxStore/constants.ts